import { render, staticRenderFns } from "./TinderTab.vue?vue&type=template&id=2cbff9d6&scoped=true"
import script from "./TinderTab.vue?vue&type=script&lang=js"
export * from "./TinderTab.vue?vue&type=script&lang=js"
import style0 from "./TinderTab.vue?vue&type=style&index=0&id=2cbff9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbff9d6",
  null
  
)

export default component.exports